export function trackEvent(name, payload = {}) {
  try {
    if (typeof window === "undefined") return;
    window.gtag?.("event", name, payload);
    window.umami?.track?.(name, payload);
  } catch {}
}

